import {
  Button,
  Form,
  Input,
  Modal,
  Row,
  Col,
  Typography,
} from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";
import BarcodeScanner from "../../Comman/Scanner/BarCodeScanner";

const { Text } = Typography;

const BinInward = ({ userData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleTagClick = () => {
    setIsModalVisible(true);
  };

  const handleScan = (value) => {
    setIsModalVisible(false);
    onFinish({ binId: value });
  };

  const handleScanError = (error) => {
    ResponseMessage.error("Error accessing camera. Please try manual input.");
    console.error(error);
  };

  const onFinish = async (values) => {
    try {
      const dataToSubmit = values.binId?.trim();

      if (!dataToSubmit) {
        ResponseMessage.error("Please provide valid Bin ID");
        return;
      }

      setIsLoading(true);

      navigate(`/bin-inward/confirm?binId=${encodeURIComponent(dataToSubmit)}`);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      ResponseMessage.error("Something went wrong");
    }
  };

  return (
    <>
      <div
        style={{
          minHeight: "420px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Row
          gutter={[32, 32]}
          justify="center"
          align="middle"
          style={{
            width: "100%",
            maxWidth: 900,
          }}
        >
          <Col xs={24} md={12}>
            <div
              className="dashboard-stat-card bg-card-blue"
              style={{
                minHeight: 220,
                display: "flex",
                alignItems: "center",
              }}
              onClick={handleTagClick}
            >
              <div
                className="dashboard-stat-card-inner"
                style={{
                  width: "100%",
                  textAlign: "center",
                  justifyContent: "center",
                  gap: 12,
                }}
              >
                <div className="dashboard-stat-title" style={{ fontSize: 18 }}>
                  Scan Bin
                </div>
               
                <Text style={{ color: "#475569" }}>
                  Click here to open barcode scanner
                </Text>
              </div>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div
              className="modern-card"
              style={{
                padding: 24,
                borderRadius: 16,
              }}
            >
              <div style={{ marginBottom: 20, textAlign: "center" }}>
                <Text strong style={{ color: "#64748b", fontSize: 16 }}>
                  Or enter Bin ID manually
                </Text>
              </div>

              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
              >
                <Form.Item
                  name="binId"
                  label="Enter Bin ID"
                  rules={[
                    {
                      required: true,
                      message: "Bin ID cannot be empty",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Enter Bin ID"
                    style={{
                      textAlign: "center",
                      borderRadius: 10,
                    }}
                  />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    loading={isLoading}
                    className="primary-btn"
                    size="large"
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </div>

      <Modal
        title="Scan QR Code"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        centered
      >
        <BarcodeScanner onScan={handleScan} onError={handleScanError} />
      </Modal>
    </>
  );
};

export default BinInward;